"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    confirm: 'אישור',
    choose_audience: 'יש לבחור סביבה קודם'
  },
  ar: {
    confirm: 'موافقة',
    choose_audience: 'يجب أوّلًا اختيار بيئة تعليميّة'
  },
  en: {
    noSchool: 'OK',
    choose_audience: 'First choose an environment'
  }
};